module.exports = __webpack_public_path__ + "img/picpay.6eb9e1b.svg";